import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  EVENT_NAME_AR,
  EVENT_NAME_EN,
} from "src/app/services/constants/general.constants";
import { HelpersService } from "@evento-ng/libs";

@Component({
  selector: "app-meeting-card",
  templateUrl: "./meeting-card.component.html",
  styleUrls: ["./meeting-card.component.scss"],
})
export class MeetingCardComponent {
  @Input() card: any;
  @Input() isMobile: any;
  constructor(
    public helpers: HelpersService,
    public translate: TranslateService
  ) {}

  gotoDetails(event: any) {
    window.location.href = location.origin + "/event-details/" + event?.id;
    this.helpers.setItemToLocalStorage(EVENT_NAME_AR, event.nameAr);
    this.helpers.setItemToLocalStorage(EVENT_NAME_EN, event.nameEn);
  }
}
